'use client'
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react'
import { Text } from '../Text'
import { TextTypes } from '../../../types'
import { ComponentTranslationContext } from '../../../providers'
import { MESSAGE_KEYS } from '../../../constants/messageKeys'

interface RichTruncateProps extends React.HTMLAttributes<HTMLDivElement> {
    lines?: number
    hasShowMore?: boolean
    children: React.ReactNode
}

export const RichTruncate = ({
    lines = 1,
    hasShowMore = false,
    children,
    className,
    ...props
}: RichTruncateProps): ReactElement => {
    const { getLabel } = useContext(ComponentTranslationContext)
    const content = useRef<HTMLDivElement>(null)
    const [isTruncated, setIsTruncated] = useState<boolean | undefined>(undefined)
    const [isExpanded, setIsExpanded] = useState<boolean>(false)
    const isClamped = !hasShowMore || !isExpanded

    useEffect(() => {
        if (!hasShowMore || !content.current || typeof isTruncated !== 'undefined') return
        if (content.current.offsetHeight < content.current.scrollHeight) {
            setIsTruncated(true)
        }
    }, [content])

    return (
        <div {...props} className={`flex flex-col ${className ?? ''}`}>
            <span
                ref={content}
                className={`${isClamped ? `line-clamp-${lines}` : ''} max-w-full`}
            >
                {children}
            </span>

            {hasShowMore && isTruncated && !isExpanded && (
                <a onClick={() => setIsExpanded(true)}>
                    <Text type={TextTypes.LINK} className="hover:underline">
                        {getLabel(MESSAGE_KEYS.SHOW_MORE)}
                    </Text>
                </a>
            )}
            {isTruncated && isExpanded && (
                <a onClick={() => setIsExpanded(false)}>
                    <Text type={TextTypes.LINK} className="hover:underline">
                        {getLabel(MESSAGE_KEYS.SHOW_LESS)}
                    </Text>
                </a>
            )}
        </div>
    )
}
